import { SET_NOT } from "./mutation-type";

export default {
    setNOT({ commit }, noticeFlag) {
        commit(SET_NOT, {noticeFlag})
    },
}